class PromoBarDropdown {
  constructor() {
    this.buttons = document.querySelectorAll('.promo-bar-dropdown__button');
    this.dropdowns = document.querySelectorAll('.promo-bar-dropdown');
    this.dropdownMap = new Map();

    this.buttons.forEach((button) => {
      const dropdownId = button.getAttribute('aria-controls');
      const dropdown = document.getElementById(dropdownId);
      this.dropdownMap.set(button, dropdown);
    });

    this.init();
  }

  init() {
    this.buttons.forEach((button) => {
      button.addEventListener('click', (e) => this.handleClick(e));
      button.addEventListener('keydown', (e) => this.handleKeydown(e));
    });

    document.addEventListener('click', (e) => this.handleOutsideClick(e));

    this.initWeglot();
  }

  handleClick(event) {
    const button = event.currentTarget;
    const dropdown = this.dropdownMap.get(button);
    const isOpen = button.getAttribute('aria-expanded') === 'true';

    this.toggleDropdown(dropdown, button, !isOpen);
  }

  handleKeydown(event) {
    if (event.code === 'Enter' || event.code === 'Space') {
      event.preventDefault();
      event.currentTarget.click();
    }
  }

  handleOutsideClick(event) {
    this.dropdowns.forEach((dropdown) => {
      const button = document.querySelector(`[aria-controls="${dropdown.id}"]`);

      if (
        !dropdown.contains(event.target) &&
        !button.contains(event.target) &&
        button.getAttribute('aria-expanded') === 'true'
      ) {
        this.toggleDropdown(dropdown, button, false);
      }
    });
  }

  toggleDropdown(dropdown, button, isOpen) {
    dropdown.classList.toggle('hidden', !isOpen);
    button.setAttribute('aria-expanded', isOpen);

    const arrow = button.querySelector('.arrow');
    if (arrow) {
      arrow.classList.toggle('rotate-180', isOpen);
    }
  }

  initWeglot() {
    Weglot.on('languageChanged', (newLang) => this.updateLanguageUI(newLang));
  }

  updateLanguageUI(currentLang) {
    const languageButton = document.querySelector('[aria-controls="language-dropdown"] span');
    if (languageButton) {
      languageButton.textContent = Weglot.getLanguageName(currentLang);
    }
  }
}

new PromoBarDropdown();
